import { SyntheticEvent, useContext } from 'react'
import { useSearchParams } from 'react-router'
import { Grid, Tab, Tabs } from '@mui/material'

import AccountsContext from '../../context'
import useStyles from '../../index.styles'

import TabButton from './tab-button'

interface ITabsComponentProps {
  tabIndex: string
}

const AccountTabsComponent = (props: ITabsComponentProps) => {
  const { tabIndex } = props

  const classes = useStyles
  const { folder, folderTree: tree } = useContext(AccountsContext)
  const [, setSearchParams] = useSearchParams()

  const childrenCount = (tree && folder && tree[folder.id] && (tree[folder.id].children || []).length) ?? 0
  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: String(newValue) })
  }

  if (folder)
    return (
      <Tabs value={tabIndex} onChange={handleTabChange} sx={classes.tabs}>
        {childrenCount > 0 && (
          <Tab
            label="Folders"
            id="tab-accounts"
            value="accounts"
            aria-label={`Folders (${childrenCount})`}
            component={TabButton}
            sx={classes.tabButtonBaseRoot}
          />
        )}
        <Tab
          label="Devices"
          id="tab-devices"
          value="devices"
          aria-label={`Devices (${folder.deviceCount})`}
          component={TabButton}
          sx={classes.tabButtonBaseRoot}
        />
        <Tab
          label="Contacts"
          id="tab-contacts"
          value="contacts"
          aria-label={`Contacts (${folder.usercount})`}
          component={TabButton}
          sx={classes.tabButtonBaseRoot}
        />
        <Tab label="Orders" id="tab-orders" value="orders" aria-label={`Orders (${folder.orderCount})`} component={TabButton} sx={classes.tabButtonBaseRoot} />
        <Tab label="Alerts" id="tab-alerts" value="alerts" aria-label="Alerts" component={TabButton} sx={classes.tabButtonBaseRoot} />
        <Tab label="About" id="tab-about" value="about" aria-label="About" sx={classes.tabButtonBaseRoot} />
      </Tabs>
    )
  return <Grid />
}

export default AccountTabsComponent
